import { render, staticRenderFns } from "./WidgetWrapper.vue?vue&type=template&id=2535a936&scoped=true&"
import script from "./WidgetWrapper.vue?vue&type=script&lang=ts&"
export * from "./WidgetWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetWrapper.vue?vue&type=style&index=0&id=2535a936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2535a936",
  null
  
)

export default component.exports